import router from '../router/index';
import config from '../../config';
import requests from '../requests';

const HOST = config.host;
const PORT =config.port;
const API_URL = ''; // HOST + ':' + PORT;
const LOGIN_URL = API_URL + '/login/'
const LOGOUT_URL = API_URL + '/logout/'

export default {

  user: {
    authenticated: false,
    role: -1
  },

  login(context, creds, redirect) {
    context.$http.post(LOGIN_URL, creds).then( (res) => {
      var data = res.body;
      if(data.action === 'success'){
        var profile = data.data;
        console.log('Data:', data);
        localStorage.setItem('id_token', profile.id)
        localStorage.setItem('access_token', data.token)
        localStorage.setItem('profile', JSON.stringify(profile))
        localStorage.setItem('expiry', data.token_expiry)
        localStorage.setItem('client', JSON.stringify(profile))

        this.user.authenticated = true;
        this.user.role = profile.role;

        requests.userHasGeneratedPass(context, profile.user_id, function (result) {
          //nYsxjz2B
          if(result.data && result.data.generated_pass) {
            context.$router.push({path:'/change_password'});
            location.reload();
          } else {
            if(redirect) {
              context.$router.push({path:redirect});
              location.reload();
            }
          }
        });

      } else {
        document.querySelector('.login-form .err').style.display = "block";
        document.querySelector('.login-form .err').innerHTML = data.msg;
        return;
      }

    }, (err) => {
      console.log(err);
      document.querySelector('.login-form .err').style.display = "block";
      return;
    });
  },

  getUserAuth(){
    return this.user.authenticated;
  },
  
  getProfile(){
    if(this.user.authenticated){
      return localStorage.getItem('profile');
    } else {
      return null;
    }
  },
  
  logout(context) {
    localStorage.removeItem('id_token');
    localStorage.removeItem('access_token');
    localStorage.removeItem('profile');
    localStorage.removeItem('client');
    localStorage.removeItem('bkd');
    this.user.authenticated = false;
    this.user.role = -1;
    context.$router.push({path:'/login'});
  },

  checkAuth() {
    var token = localStorage.getItem('id_token')
    var exp = localStorage.getItem('expiry');
    var d = new Date(exp);
    if(token && d > new Date()) {
      var user = localStorage.getItem('profile');
      user = JSON.parse(user);
      this.user.authenticated = true
      this.user.role = user.role;
    }
    else {
      this.user.authenticated = false
      this.user.role = -1
    }
  },

  getAuthHeader() {
    return {
      'x-access-token': localStorage.getItem('access_token'),
      'content-type':'application/json',
      'Accept': 'application/json'
    }
  },
  
  getApi(){
    return API_URL;
  }
  
}


// WEBPACK FOOTER //
// ./src/auth/index.js